var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { makeObservable, action, observable } from 'mobx';
var WorkflowStore = /** @class */ (function () {
    function WorkflowStore() {
        Object.defineProperty(this, "caseType", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "caseId", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "takePhoto", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "acceptPhoto", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "rejectPhoto", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "finish", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        makeObservable(this);
        window.$WorkflowStore = this;
    }
    Object.defineProperty(WorkflowStore.prototype, "init", {
        enumerable: false,
        configurable: true,
        writable: true,
        value: function (caseId, caseType, takePhoto, acceptPhoto, rejectPhoto, finish) {
            this.caseId = caseId;
            this.caseType = caseType;
            this.takePhoto = takePhoto;
            this.acceptPhoto = acceptPhoto;
            this.rejectPhoto = rejectPhoto;
            this.finish = finish;
        }
    });
    __decorate([
        observable
    ], WorkflowStore.prototype, "caseType", void 0);
    __decorate([
        observable
    ], WorkflowStore.prototype, "caseId", void 0);
    __decorate([
        observable
    ], WorkflowStore.prototype, "takePhoto", void 0);
    __decorate([
        observable
    ], WorkflowStore.prototype, "acceptPhoto", void 0);
    __decorate([
        observable
    ], WorkflowStore.prototype, "rejectPhoto", void 0);
    __decorate([
        observable
    ], WorkflowStore.prototype, "finish", void 0);
    __decorate([
        action
    ], WorkflowStore.prototype, "init", null);
    return WorkflowStore;
}());
export default WorkflowStore;
